import React from "react";
import { Info } from "lucide-react";
const costData = [{
  id: 1,
  treatment: "Impianto Singolo (Alpha Bio)",
  includes: "Impianto + moncone",
  price: "€\u00A0350",
  crownMetal: "Corona metallo-ceramica: 120\u00A0€",
  crownZirconia: "Corona zirconio: 170\u00A0€"
}, {
  id: 2,
  treatment: "Impianto Singolo (Nobel Biocare)",
  includes: "Impianto + moncone",
  price: "€\u00A0700",
  crownMetal: "Corona metallo-ceramica: 120\u00A0€",
  crownZirconia: "Corona zirconio: 170\u00A0€"
}, {
  id: 3,
  treatment: "Impianto Singolo (Straumann)",
  includes: "Impianto + moncone",
  price: "€\u00A0800",
  crownMetal: "Corona metallo-ceramica: 120\u00A0€",
  crownZirconia: "Corona zirconio: 170\u00A0€"
}, {
  id: 4,
  treatment: "All-on-4 (Arcata Completa)",
  includes: "Arcata completa su 4 impianti",
  price: "€\u00A02.940",
  crownMetal: "Metallo-ceramica: 2.940\u00A0€",
  crownZirconia: "Zirconio: 3.420\u00A0€"
}];
export default function AnalisiComparativaDeiCosti() {
  return <section id="analisi-comparativa-dei-costi" className="dark bg-background text-foreground py-24 px-4 md:px-8 scroll-mt-20 md:scroll-mt-0">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="font-default text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight mb-4">
            Listino 2026 per voce
          </h2>
          <p className="text-muted-foreground text-lg max-w-2xl mx-auto">
            Il listino 2026 di SkyDental Tirana per i trattamenti implantari più richiesti, voce per voce.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-8">
          {costData.map((item, i) => {
          const [metalLabel, metalValue] = item.crownMetal.split(": ");
          const [zirconiaLabel, zirconiaValue] = item.crownZirconia.split(": ");
          return <div key={item.id} data-index={i} className="flex flex-col justify-between rounded-2xl border border-border bg-card p-6 md:p-8 shadow-sm transition-colors hover:border-primary/50">
                <div>
                  <h3 className="font-serif text-2xl font-medium text-foreground tracking-tight mb-3">
                    {item.treatment}
                  </h3>
                  <div className="pt-4 border-t border-border/60">
                    <span className="text-xs uppercase tracking-wider text-muted-foreground font-medium block mb-1">
                      Cosa comprende
                    </span>
                    <p className="text-sm text-foreground/90 font-medium">
                      {item.includes}
                    </p>
                  </div>
                </div>

                <div className="mt-8 pt-6 border-t border-border/60">
                  <span className="text-xs uppercase tracking-wider text-muted-foreground font-medium block mb-1">
                    Prezzo 2026 (SkyDental)
                  </span>
                  <div className="font-mono text-3xl lg:text-4xl font-semibold text-primary tracking-tight mb-4 whitespace-nowrap">
                    {item.price}
                  </div>
                  <div className="rounded-lg bg-muted/40 border border-border/40 px-3.5 py-2.5 text-xs text-muted-foreground space-y-1.5">
                    <div className="flex items-center justify-between gap-3">
                      <span className="font-medium text-foreground/80">{metalLabel}</span>
                      <span className="font-mono text-foreground whitespace-nowrap">{metalValue}</span>
                    </div>
                    <div className="flex items-center justify-between gap-3">
                      <span className="font-medium text-foreground/80">{zirconiaLabel}</span>
                      <span className="font-mono text-foreground whitespace-nowrap">{zirconiaValue}</span>
                    </div>
                  </div>
                </div>
              </div>;
        })}
        </div>

        <div className="mt-8 flex items-start gap-3 text-sm text-muted-foreground bg-muted/30 p-4 rounded-lg border border-border/50">
          <Info className="size-5 text-primary shrink-0 mt-0.5" />
          <p>
            <strong>Nota bene:</strong> I prezzi indicati si riferiscono alle tariffe ufficiali di SkyDental Tirana per il 2026. 
            Il costo finale può variare in base alla situazione clinica specifica del paziente valutata durante la consultazione gratuita.
          </p>
        </div>
      </div>
    </section>;
}